import { createLucideIcon } from './lucideIcon'

export const ArrowUp = createLucideIcon(
  'ArrowUp',
  <>
    <path d="m5 12 7-7 7 7" />
    <path d="M12 19V5" />
  </>
)
